import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";

export enum Language {
  Hebrew = "heb",
}

/**
 * a minimal translations service that loads translation from a json file located in
 * the assets'  folder.
 */
@Injectable()
export class I18nService {
  private currentLanguage: Language.Hebrew;
  private translations: Record<Language, Record<string, string>>;
  private readonly hebrewJSONUrl = "assets/translations/hebrew.json";

  constructor(private http: HttpClient) {
    this.getTranslationsAsPromise().then();
  }
  public static formatDateToString(date: Date) {
    return `${date.getDate()}.${date.getMonth() + 1}.${
      date.getFullYear() - 2000
    }`;
  }

  public async getTranslations() {
    if (this.translations) {
      return this.translations[this.currentLanguage];
    }
    return this.getTranslationsAsPromise();
  }

  public async getTranslationsAsPromise(): Promise<Record<string, string>> {
    const fromJson = (await this.getJSON().toPromise()) as Record<
      string,
      string
    >;
    this.translations = { ...this.translations };
    this.translations[this.currentLanguage] = fromJson;
    return fromJson;
  }

  private getJSON(): Observable<Record<string, string>> {
    return this.http.get(this.hebrewJSONUrl) as Observable<
      Record<string, string>
    >;
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/i18n.service.ts